import client from "./client";

const getCurrencies = () => client.get("/subsidiary/dashboard/service/currencies");
const getCountries = () => client.get("/subsidiary/dashboard/service/countries");

export default { getCurrencies, getCountries };